import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';

import { PLAN_YEAR_OPTIONS } from '../../report.types';

interface Props {
  testId?: string;
  value: OptionKey[];
  disabled?: boolean;
  onChangeValue: (value: OptionKey[]) => void;
}
const PlanYearSelector: React.FC<Props> = ({
  testId = 'plan_year_selector',
  disabled,
  value,
  onChangeValue,
}) => {
  const currentValue = useMemo(() => {
    if (!value.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return value;
  }, [disabled, value]);

  const handleChangeValue = useSelectAllHandler(value, onChangeValue);

  return (
    <SelectDropdown
      ellipsisMode
      testId={testId}
      disabled={disabled}
      activeTitle
      options={PLAN_YEAR_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Plan year"
      id="plan_year_selector"
      name="plan_year_selector"
      allMode
    />
  );
};

export default PlanYearSelector;
